import { Box, Icon, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { borderRadius, palette, spaces } from '../../assets/styles/themes/tokens';
import { UserPaymentMethodType } from '../../types/User';
import getMuiIcon, { type IconName } from '../../utils/getMuiIcon';

interface PaymentMethodsViewProps {
	currentMethodIcon: IconName;
	currentMethodText: string;
}

const PaymentMethodsView = ({ currentMethodIcon, currentMethodText }: PaymentMethodsViewProps) => {
	const { t } = useTranslation();

	return (
		<>
			<Box sx={{ display: 'inline-flex', alignItems: 'center' }}>
				<Box
					sx={{
						height: '46px',
						display: 'flex',
						marginRight: spaces.md,
						paddingX: spaces.xs,
						paddingY: `calc(${spaces.sm} - 2px)`,
						alignItems: 'center',
						borderRadius: borderRadius.xs,
						border: `1px solid ${palette.elevation.outlined}`,
						'& svg': { width: 'auto', height: 'auto' },
					}}
				>
					<Icon component={getMuiIcon(currentMethodIcon)} />
					{currentMethodText === '' && (
						<Typography sx={{ marginLeft: spaces.xxs, fontSize: '12px' }}>{t('Invoice')}</Typography>
					)}
				</Box>
				{currentMethodText !== UserPaymentMethodType.INVOICE && (
					<Typography>{currentMethodText}</Typography>
				)}
			</Box>
		</>
	);
};

export default PaymentMethodsView;
